<template>
    <div>
        <div class="columns pt-6" v-if="isTreasurehunt">
            <div class="column">
                <p
                    v-t="'Sessions.clue_solved_in_less_time'"
                    class="
                        title
                        has-text-primary
                        is-5
                        has-text-weight-bold has-text-centered
                    "
                ></p>
                <div class="box">
                    <p
                        class="title is-6 has-text-weight-bold"
                        v-html="lessTimeClue.description"
                    ></p>
                </div>
            </div>
            <div class="column">
                <p
                    v-t="'Sessions.clue_solved_in_more_time'"
                    class="
                        title
                        has-text-primary
                        is-5
                        has-text-weight-bold has-text-centered
                    "
                ></p>
                <div class="box">
                    <p
                        class="title is-6 has-text-weight-bold"
                        v-html="moreTimeClue.description"
                    ></p>
                </div>
            </div>
            <div class="column">
                <p
                    v-t="'Sessions.clue_in_need_of_more_help'"
                    class="
                        title
                        has-text-primary
                        is-5
                        has-text-weight-bold has-text-centered
                    "
                ></p>
                <div class="box">
                    <p
                        class="title is-6 has-text-weight-bold"
                        v-html="moreHelpClue.description"
                    ></p>
                </div>
            </div>
        </div>

        <div class="columns pt-6">
            <div class="column">
                <p
                    v-t="'Sessions.most_correct_question'"
                    class="
                        title
                        has-text-primary
                        is-5
                        has-text-weight-bold has-text-centered
                    "
                ></p>
                <div class="box">
                    <p class="title is-6 has-text-weight-bold">
                        {{ easiestQuestion.title }}
                    </p>
                </div>
            </div>
            <div class="column">
                <p
                    v-t="'Sessions.mostFailedQuestionTitle'"
                    class="
                        title
                        has-text-primary
                        is-5
                        has-text-weight-bold has-text-centered
                    "
                ></p>
                <div class="box">
                    <p class="title is-6 has-text-weight-bold">
                        {{ mostFailedQuestion.title }}
                    </p>
                </div>
            </div>
            <div class="column">
                <p
                    v-t="'Sessions.mostTimeRequiringQuestionTitle'"
                    class="
                        title
                        has-text-primary
                        is-5
                        has-text-weight-bold has-text-centered
                    "
                ></p>
                <div class="box">
                    <p class="title is-6 has-text-weight-bold">
                        {{ mostTimeRequiringQuestion.title }}
                    </p>
                </div>
            </div>
        </div>

        <div class="columns is-centered pt-6">
            <div class="column">
                <p
                    v-t="'Sessions.ranking_title'"
                    class="
                        title
                        has-text-primary
                        is-5
                        has-text-weight-bold has-text-centered
                    "
                ></p>
                <session-detail-ranking
                    :ranking="scoreRanking"
                    :units="$t('Constants.POINTS')"
                />
            </div>
            <div class="column">
                <p
                    v-t="'Sessions.speed_podium'"
                    class="
                        title
                        has-text-primary
                        is-5
                        has-text-weight-bold has-text-centered
                    "
                ></p>
                <session-detail-ranking
                    :ranking="timeRanking"
                    :units="$t('Constants.TIME_UNITS_MINUTES')"
                    :field="'formattedTime'"
                />
            </div>
        </div>
    </div>
</template>

<script>
import _ from 'underscore';
import SessionDetailRanking from '@/components/SessionDetailRanking';
import { getSessionRankingStatistics } from '@/services/API';
import { timeFormat } from '@/lib/helpers';
export default {
    components: {
        SessionDetailRanking,
    },
    props: {
        questions: {
            type: Array,
            default: () => {
                return [];
            },
        },
        clues: {
            type: Array,
            default: () => {
                return [];
            },
        },
        isTreasurehunt: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            scoreRanking: [],
        };
    },
    computed: {
        easiestQuestion() {
            return _.max(this.questions, (question) => {
                return question.totalScore;
            });
        },
        mostFailedQuestion() {
            return _.min(this.questions, (question) => {
                return question.hitRate;
            });
        },
        mostTimeRequiringQuestion() {
            return _.max(this.questions, (question) => {
                return question.totalTime;
            });
        },
        timeRanking() {
            return _.chain(this.scoreRanking)
                .sortBy((score) => {
                    return +score.time;
                })
                .map((user) => {
                    user.formattedTime = timeFormat(user.time);
                    return user;
                })
                .value();
        },
        lessTimeClue() {
            return _.min(this.clues, (clue) => {
                return clue.totalTime;
            });
        },
        moreTimeClue() {
            return _.max(this.clues, (clue) => {
                return clue.totalTime;
            });
        },
        moreHelpClue() {
            return _.max(this.clues, (clue) => {
                return clue.totalTime;
            });
        },
    },
    mounted() {
        getSessionRankingStatistics(this.$route.params._id).then(({ data }) => {
            this.scoreRanking = data;
        });
    },
};
</script>

<style></style>
